import qs from 'qs';
import { AxiosInstance } from 'axios';
import { OffsetPaginationInput } from '@app/data/inputs';
import { CollectionResource } from '@app/data/resources';
import { AiBookmarkedImageFilterInput, AiImageFilterInput, GenerateAiImageInput } from './inputs';
import { AiImageRef } from './refs';
import { AiImageResource, ModelSchemaResource } from './resources';

export default class AiImage {
    private basePath = '/api/ai-image';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Fetches list of models and their schema
    getModelSchemaList = async (): Promise<CollectionResource<ModelSchemaResource, {}>> => {
        const { data } = await this.http.get(`${this.basePath}/schema/model`);

        return data;
    };

    // Get list of AI images
    getAiImageList = async (
        pagination: OffsetPaginationInput,
        filter?: AiImageFilterInput
    ): Promise<CollectionResource<AiImageResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/item?${query}`);

        return data;
    };

    // Get lis of AI images
    getAiBookmarkedImageList = async (
        pagination: OffsetPaginationInput,
        filter?: AiBookmarkedImageFilterInput
    ): Promise<CollectionResource<AiImageResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/item/bookmark?${query}`);

        return data;
    };

    // Fetch single AI Image
    getById = async (id: ID): Promise<AiImageResource> => {
        const { data } = await this.http.get(`${this.basePath}/item/${id}`);
        return data;
    };

    // Generate AI image
    generate = async (input: GenerateAiImageInput): Promise<AiImageRef> => {
        // Get current timeout
        const defaultTimeout = this.http.defaults.timeout;

        // Update timeout
        this.http.defaults.timeout = 60000;

        const { data } = await this.http.post(`${this.basePath}/generate`, input);

        // Return old timeout value back
        this.http.defaults.timeout = defaultTimeout;

        return data;
    };

    // Add AI image to personal bookmark
    bookmark = async (id: ID): Promise<AiImageRef> => {
        const { data } = await this.http.put(`${this.basePath}/item/${id}/bookmark`);
        return data;
    };

    // Remove AI image from personal bookmarks
    removeBookmark = async (id: ID): Promise<AiImageRef> => {
        const { data } = await this.http.delete(`${this.basePath}/item/${id}/bookmark`);
        return data;
    };
}
